export const riskLevels = [
    { id: "low", title: "Lower risk", description: "Prioritise resilience, stability, and lower volatility." },
    { id: "balanced", title: "Balanced", description: "Blend quality, impact, and measured market exposure." },
    { id: "growth", title: "Growth", description: "Accept higher volatility for stronger upside potential." },
    { id: "high-conviction", title: "High conviction", description: "Concentrated exposure to themes with meaningful impact ambition." },
];

export const impactLevels = [
    { id: "aware", title: "Aware", description: "Avoid obvious harm and improve transparency." },
    { id: "aligned", title: "Aligned", description: "Prefer companies aligned with clear sustainability goals." },
    { id: "measurable", title: "Measurable", description: "Seek visible metrics, evidence, and progress over time." },
    { id: "transformational", title: "Transformational", description: "Prioritise businesses enabling systemic change." },
];

export const impactTypes = [
    "Climate transition",
    "Nature and biodiversity",
    "Health and wellbeing",
    "Inclusive growth",
    "Responsible technology",
    "Governance quality",
];

export const sdgAreas = [
    { id: 1, title: "No Poverty", color: "bg-red-600" },
    { id: 2, title: "Zero Hunger", color: "bg-amber-500" },
    { id: 3, title: "Good Health", color: "bg-green-600" },
    { id: 4, title: "Quality Education", color: "bg-red-700" },
    { id: 5, title: "Gender Equality", color: "bg-orange-600" },
    { id: 6, title: "Clean Water", color: "bg-sky-500" },
    { id: 7, title: "Clean Energy", color: "bg-yellow-500" },
    { id: 8, title: "Decent Work", color: "bg-rose-700" },
    { id: 9, title: "Innovation", color: "bg-orange-500" },
    { id: 10, title: "Reduced Inequalities", color: "bg-pink-600" },
    { id: 11, title: "Sustainable Cities", color: "bg-yellow-600" },
    { id: 12, title: "Responsible Consumption", color: "bg-amber-700" },
    { id: 13, title: "Climate Action", color: "bg-emerald-700" },
    { id: 14, title: "Life Below Water", color: "bg-blue-500" },
    { id: 15, title: "Life on Land", color: "bg-lime-600" },
    { id: 16, title: "Peace and Justice", color: "bg-blue-800" },
    { id: 17, title: "Partnerships", color: "bg-indigo-900" },
];
